import { ImageButtonPanel } from '../../../components/ImageButtonPanel/ImageButtonPanel'

import './menu.style.css'

const btns: Parameters<typeof ImageButtonPanel>[0][] = [
  {
    imageName: 'assembling',
    text: 'Сборка',
    textSecondary: 'Сборка и сортировка',
    target: '',
    disabled: true,
  },
  {
    imageName: 'issue',
    text: 'Выдача',
    textSecondary: 'Грузов курьерам и моб складам',
    target: '',
    disabled: true,
  },
  {
    imageName: 'acceptance',
    text: 'Приемка',
    textSecondary: 'Грузов от курьеров',
    target: '',
    disabled: true,
  },
  {
    imageName: 'inventory',
    text: 'Инвентаризация',
    textSecondary: 'Проверка грузов',
    target: '',
    disabled: true,
  },
  {
    imageName: 'invoice',
    text: 'Квитанция',
    textSecondary: 'Отправка квитанции об услуге',
    target: '/panel/invoice',
  },
].map((b, i) => ({ ...b, inverted: i % 2 !== 0 }))

export const Menu = () => {
  const list = btns.map((btn, index) => {
    const { imageName, text, textSecondary, inverted, target, disabled } = btn

    return (
      <ImageButtonPanel
        key={index}
        imageName={imageName}
        text={text}
        target={target}
        textSecondary={textSecondary}
        inverted={inverted}
        disabled={disabled}
      />
    )
  })

  return (
    <div className="panel-menu__content">
      <div className="panel-menu__content-menu">{list}</div>
    </div>
  )
}
